Directives.SecurityPhoneNumberDirective = function SecurityPhoneNumberDirective() {

    // @ngInject
    function SecurityPhoneNumberDirectiveControllerFunc($scope, $injector, UsersManager, UserService, ModalService, PopupMessageService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SecurityPhoneNumberDirectiveController';

        this.UsersManager = UsersManager;
        this.UserService = UserService;
        this.ModalService = ModalService;
        this.PopupMessageService = PopupMessageService;

        // 2FA
        this.enablePhoneEdit = false;
        this.verificationCode = "";
        this.errorMessage = "";
        this.phoneNumberRegex = new RegExp(/^\+?(\d+)$/);

        this.setPhoneNumberModel();
    }

    var SecurityPhoneNumberDirectiveController = Class(Controllers.BaseController, {
        constructor: SecurityPhoneNumberDirectiveControllerFunc,

        startTwoFactorAuth: function startTwoFactorAuth() {
            return this.ModalService.openTwoFactorAuthModal(true).then(
                function confirm(result) {
                    this.onTwoFactorAuthDone(result);
                }.bind(this),
                function cancel(error) {
                    this.onTwoFactorAuthDone(error);
                }.bind(this)
            );
        },

        setPhoneNumberModel: function setPhoneNumberModel() {
            var phoneNumber = this.user.securityPhoneNumberLastFourDigits();

            if(phoneNumber){

                this.securityPhoneNumber = "xxxxxx" + phoneNumber;
            }else{

                this.enablePhoneEdit = true;
            }
        },

        onTwoFactorAuthDone: function onTwoFactorAuthDone(result) {

            // if verification failed, show message
            if(result === 'invalid') {
                this.errorMessage = "Invalid verification code";
                return;
            }

            // dismissed
            if(result === 'cancel') {
                return;
            }

            // all good, code is verified!
            this.enablePhoneEdit = true;
            this.verificationCode = result;
        },

        updateSecurityPhoneNumber: function updateSecurityPhoneNumber(securityPhoneNumber, form) {

            if(this.user.securityPhoneNumberLastFourDigits() && !this.verificationCode) {
                return;
            }

            this.setPhoneNumberValidity(securityPhoneNumber, form);

            if(form.$valid) {
                this.show_loading = true;

                this.UsersManager.updateSecurityPhoneNumber(securityPhoneNumber, this.verificationCode)
                    .then(function success() {
                        console.log("SUCCESS: " + securityPhoneNumber);
                    }.bind(this))
                    .catch(function error(result) {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error,  result.data.error_message || 'Error updating 2fa phone number');
                    }.bind(this))
                    .finally(function finallyDo() {
                        console.log("FINALY: " + securityPhoneNumber);
                        this.show_loading = false;
                        this.resetEditing();
                    }.bind(this));
            }

        },

        setPhoneNumberValidity: function(securityPhoneNumber, form) {
            var validPhoneNumber = this.phoneNumberRegex.test(securityPhoneNumber);
            form.security_phone_number.$setValidity('invalid', validPhoneNumber);
        },

        securityPhoneNumberExist: function securityPhoneNumberExist() {
            return !!this.user.securityPhoneNumberLastFourDigits();
        },

        resetEditing: function resetEditing() {
            this.verificationCode = undefined;
            this.enablePhoneEdit = false;
            this.formChangeSecurityPhoneNumber.security_phone_number.$setValidity('invalid', true);
            this.setPhoneNumberModel();
        },

        qualificationPeriodPassed: function qualificationPeriodPassed() {
            return this.UserService.has2FAQualificationPeriodPassed(this.user);
        }
    });

    return {
        scope: {
            user: '=user'
        },
        templateUrl: 'angular/app/modules/core/features/settings/account/security_phone_number/security_phone_number_template.html',
        controller: SecurityPhoneNumberDirectiveController,
        controllerAs: 'securityPhoneNumberVm',
        bindToController: true
    };
};
